import { render, staticRenderFns } from "./HelpdeskServerity.vue?vue&type=template&id=347a167e&scoped=true"
import script from "./HelpdeskServerity.ts?vue&type=script&lang=ts&external"
export * from "./HelpdeskServerity.ts?vue&type=script&lang=ts&external"
import style0 from "./HelpdeskServerity.vue?vue&type=style&index=0&id=347a167e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "347a167e",
  null
  
)

export default component.exports